module.exports = __webpack_public_path__ + "img/logoESP.7adc77a4.png";